import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import {UsePost, UsePut} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";
import Form from "./Form";


const Edit = ({id}) => {


    const [landing, setLanding] = useState()
    const [errors, setErrors] = useState()
    const [domains, setDomains] = useState([])
    const [enterprises, setEnterprises] = useState([])
    const [isLoading, setIsLoading] = useState(true)


    const GetEntities = async () => {
        const requestLanding = await UsePut(
            `/landings/get/${id}`,
            {data: {limit: 1, offset: 0, _id: id}}
        )

        const requestEnterprises = await UsePut(
            `/enterprises/get`,
            {data: {offset: 0}, toArray: true, propLabel: 'name'}
        )


        const requestDomains = await UsePut(
            `/domains/get`,
            {
                toArray: true,
                propLabel: 'name',
                data: {
                    id_enterprise: requestLanding?.entities[0].id_enterprise?.$oid,
                },
            }
        )


        return {
            domains    : requestDomains,
            landing    : requestLanding?.entities[0],
            enterprises: requestEnterprises,
        }
    }


    useEffect(() => {
        GetEntities().then((response) => {
            setLanding(response.landing)
            setDomains(response.domains)
            setEnterprises(response.enterprises)
            setIsLoading(false)
        })
    }, [])


    const handleUpdate = (PostData) => {
        setIsLoading(true)
        UsePost(
            `/landings/upsert/${id}`,
            {data: PostData}
        ).then((response) => {
            window.setTimeout(() => {
                if (response.code >= 200 && response.code <= 299) {
                    UseMessage('success', 'Landing has been successfully updated')
                    setErrors(undefined)
                } else {
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }


    const handleDomains = async (ev) => {
        const requestDomains = await UsePut(
            "/domains/get",
            {data: {id_enterprise: ev.value}, toArray: true, propLabel: 'name'}
        )
        setDomains(requestDomains)
    }



    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form
                                errors={errors}
                                landing={landing}
                                domains={domains}
                                isReady={!isLoading}
                                onSubmit={handleUpdate}
                                enterprises={enterprises}
                                onChangeEnterprise={handleDomains}
                            />
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Edit